<template>
    <div>
        <div style="padding-bottom:0.35rem;">
          <span class="us_block_title">报障工单</span>
          <span class="us_block_more_text" @click="goList">
            <span>更多</span><i class="fa fa-angle-right" aria-hidden="true"></i>
          </span>
        </div>
        <LoadingText v-if="loading" />
        <!-- <v-card  flat style="background-color:#fff;" > -->
        <div v-else v-for="item in list" :key="item.GZ_ORDER_ID" style="background:#fff;">
            <OrderCard :orderInfo="item" flat  />
        </div>
        <!-- </v-card> -->
        <div v-if="list.length === 0 && !loading" style="text-align:center;background:#fff;padding:1rem 0;">
          <!-- <div><img src="/res/no_record.jpg" alt="no_record"></div> -->
          <div style="font-size:0.8rem;color:#9e9e9e;">暂无未处理工单</div>
        </div>
    </div>
</template>

<script>
import OrderCard from '../../Biz/Order/OrderCard'
import LoadingText from '../../components/LoadingText'
export default {
  components: {
    OrderCard,
    LoadingText
  },
  props: {
  },
  data() {
    return {
      list: [],
      loading: true,
      timeout: null,
      execute: true,
      comparyName: ''
    }
  },
  computed: {
  },
  mounted() {
  },
  created() {
    this.getListTask()
  },
  destroyed() {
    var that = this
    if (that.timeout) {
      window.clearTimeout(that.timeout)
    }
  },
  activated() {
    this.getListTask();
  },
  deactivated() {
    var that = this
    if (that.timeout) {
      window.clearTimeout(that.timeout)
    }
  },
  methods: {
    goList() {
      this.$router.goPage('/OrderList')
    },
    async getList() {
      var that = this
      await that.$api.bz.getLastOrderList({ biz_sid: -2 }).then(res => {
        // console.log('getLastOrderList.res', res);
        if (!res.success) {
          that.loading = false
          console.log('获取最近报障工单失败', res);
          return
        }
        var data = res.data
        that.list = data
        // that.list = []
        // that.getCompanyName()
        // for (let index = 0; index < data.length; index++) {
        //   const item = data[index];
        //   item['company_name'] = that.comparyName
        //   that.list.push(item)
        // }
        that.loading = false
      })
    },
    async getListTask() {
      var that = this;
      if (that.timeout) {
        window.clearTimeout(that.timeout);
      }
      await that.getList();
      that.timeout = setTimeout(that.getListTask, 30 * 1000);
    },
    // 获取公司名称
    getCompanyName() {
      var that = this
      if (that.execute) {
        const customData = this.$AppHelper.getCustomData()
        if (customData === '' || !customData) {
          return
        }
        const comparyInfo = customData.company_info
        if (comparyInfo === '' || !comparyInfo) {
          return
        }
        that.comparyName = comparyInfo.COMPANY_NAME
        // console.log(that.comparyName)
        that.execute = false
      }
    }
  }
}
</script>

<style scoped>
.us_block_title{
  font-weight:bold;
  font-size:1.05rem;
  color: rgba(33,33,33,0.9);
}
.us_block_more_text{
  font-size:0.8rem;
  padding-top:0.3rem;
  padding-right:0.4rem;
  float:right;
  color:#9e9e9e;
  cursor: pointer;
}
.us_block_more_text span{
  font-size:0.8rem;
}
.us_block_more_text i{
  margin-left:0.4rem;
}
</style>
